module.exports = __webpack_public_path__ + "static/media/star_icon.1cc54d68.svg";